// "앱 보안" - 지문 로그인 on/off + 잠금까지의 유휴 시간(기본 5분). 앱(Capacitor)에서만 보인다.
// PushSettings.js/LoginSessions.js와 같은 자리(프로필 화면, 사용자별 개인 설정) - 2026-10-16.
import React, { useState } from 'react';
import { Box, FormControlLabel, Switch, Typography, MenuItem, Select, Stack } from '@mui/material';
import { useSnackbar } from 'notistack';
import {
  isNative,
  isBiometricEnabled,
  setBiometricEnabled,
  getLockTimeoutMinutes,
  setLockTimeoutMinutes,
  checkBiometryAvailable,
} from '../../lib/biometricLock';

const TIMEOUT_OPTIONS = [1, 5, 15, 30];

const BiometricSettings = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [enabled, setEnabled] = useState(isBiometricEnabled());
  const [timeoutMin, setTimeoutMin] = useState(getLockTimeoutMinutes());

  if (!isNative()) {
    return null; // 웹 브라우저: 기능 자체가 없음(변경 불가)
  }

  const handleToggle = async (checked) => {
    if (checked) {
      const info = await checkBiometryAvailable();
      if (!info?.isAvailable) {
        enqueueSnackbar('이 기기에서 지문/얼굴 인증을 쓸 수 없습니다.', { variant: 'warning' });
        return;
      }
    }
    setBiometricEnabled(checked);
    setEnabled(checked);
  };

  const handleTimeoutChange = (value) => {
    setLockTimeoutMinutes(value);
    setTimeoutMin(value);
  };

  return (
    <Box>
      <FormControlLabel
        sx={{ justifyContent: 'space-between', ml: 0, width: '100%' }}
        labelPlacement="start"
        control={<Switch checked={enabled} onChange={(e) => handleToggle(e.target.checked)} />}
        label={<Typography variant="body2">지문/얼굴로 잠금 해제</Typography>}
      />
      {enabled && (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            백그라운드로 전환 후
          </Typography>
          <Select
            size="small"
            value={timeoutMin}
            onChange={(e) => handleTimeoutChange(e.target.value)}
          >
            {TIMEOUT_OPTIONS.map((m) => (
              <MenuItem key={m} value={m}>
                {m}분
              </MenuItem>
            ))}
          </Select>
          <Typography variant="body2" color="text.secondary">
            지나면 잠금
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default BiometricSettings;
